import React from "react";

export default function Manifesto() {
  return (
    <section
      data-testid="manifesto-section"
      className="relative bg-black border-y border-white/10 py-20 lg:py-28 overflow-hidden"
    >
      <div className="absolute inset-0 tech-grid opacity-30 pointer-events-none" />
      <div className="relative max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-start">
          <div className="lg:col-span-3 flex items-start gap-4">
            <span className="font-mono text-brand-red text-xs tracking-widest">00</span>
            <span className="label-eyebrow">The Philosophy</span>
          </div>

          <div className="lg:col-span-9">
            <h2 className="font-display uppercase text-white text-4xl sm:text-5xl lg:text-6xl xl:text-7xl leading-[0.95] tracking-tight max-w-5xl">
              Precise programs.{" "}
              <span className="text-brand-red">Not random sessions.</span>
            </h2>

            <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-px bg-white/10 border-y border-white/10">
              <ManifestoCell
                k="01"
                title="Every session"
                body="has a purpose."
              />
              <ManifestoCell
                k="02"
                title="Every program"
                body="has progression."
              />
              <ManifestoCell
                k="03"
                title="A plan built"
                body="around you."
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function ManifestoCell({ k, title, body }) {
  return (
    <div
      data-testid={`manifesto-cell-${k}`}
      className="bg-black p-6 lg:p-8 flex items-start gap-5"
    >
      <span className="font-mono text-brand-red text-xs tracking-widest pt-2">
        /{k}
      </span>
      <div>
        <div className="font-display uppercase text-white text-2xl lg:text-3xl tracking-wide leading-tight">
          {title}
        </div>
        <div className="font-display uppercase text-white/55 text-2xl lg:text-3xl tracking-wide leading-tight">
          {body}
        </div>
      </div>
    </div>
  );
}
